<template>
</template>
<script>
  import Vue from 'vue'
  import { validationMixin } from 'vuelidate'
  import {
    required,
    email,
    minLength,
    maxLength
  } from 'vuelidate/lib/validators'

  export default {
    name: 'BraveForm',
    mixins: [validationMixin],
    data: () => ({
      submitSuccess: false,
      sending: false,
      awaitingResponse: false
    }),
    methods: {
      getValidationClass (fieldName) {
        const field = this.$v.form[fieldName]
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      clearForm () {
        this.$v.$reset()
      },
      submit () {
        this.sending = true
        this.awaitingResponse = true

        this.onSubmit()

      },
      afterSubmit (lockFields = false) {
        if (!lockFields) {
          this.sending = false
        }
        this.awaitingResponse = false

      },
      validate () {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          this.submit()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// lib/brave-form/components/extension.vue